/**
 * 组织管理接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DepartmentManagementService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;

   //钉钉相关
   out:string = environment.saasWebAPI
 
   //任务调度微服务api
   activitiWebAPI: string = environment.activitiWebAPI;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 组织管理接口
  /**
   * 分页查询组织
   * @param param
   * @returns {Observable<any>}
   */
   queryOptionTree(param) {
    const url = this.prefix + 'organize/queryOptionTree'+param;
    return this.http.Get(url);
  }

  /**
   * 分页查询组织
   * @param param
   * @returns {Observable<any>}
   */
  queryOrganizePageList(param) {
    const url = this.prefix + 'organize/queryPageList';
    return this.http.Post(url, param);
  }

    /**
   * 分页查询岗位
   * @param param
   * @returns {Observable<any>}
   */
     queryPositionPageList(param) {
      const url = this.prefix + 'position/queryPageList';
      return this.http.Post(url, param);
    }

  /**
   * 删除组织
   * @param param
   * @returns {Observable<any>}
   */
  deleteOrganize(param) {
    const url = this.prefix + 'organize/deleteBatch';
    return this.http.Post(url, param);
  }
 /**
   * 根据部门ID查部门负责人
   * @param param
   * @returns {Observable<any>}
   */
  queryOrgRoleUsers(param) {
    const url = this.prefix + 'role/queryOrgRoleUsers?orgId='+param.orgId+'&roleCode=BMZR&systemId='+param.systemId;
    return this.http.Post(url, "");
  }

  /**
   * 修改组织
   * @param param
   * @returns {Observable<any>}
   */
  updateOrganize(param) {
    const url = this.prefix + 'organize/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 获取单个组织信息
   * @param param
   * @returns {Observable<any>}
   */
  queryOrganizeById(param) {
    const url = this.prefix + 'organize/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 新增组织
   * @param param
   * @returns {Observable<any>}
   */
  saveOrganize(param) {
    const url = this.prefix + 'organize/save';
    return this.http.Post(url, param);
  }

  /**
   * 无管理权限获取组织列表
   * @param param
   * @returns {Observable<any>}
   */
  queryList(param) {
    const url = this.activitiWebAPI + 'organize/queryList';
    return this.http.Post(url, param);
  }

  /**
   * 查询组织是否已同步到钉钉
   * @param param
   * @returns {Observable<any>}
   */
  getSyncList(param) {
    const url = this.prefix + 'orgDingtalk/getSyncList';
    return this.http.Post(url, param);
  }

  /**
   * 查询组织是否已同步到钉钉
   * @param param
   * @returns {Observable<any>}
   */
  departmentGet(param) {
    const url = this.out + 'dingtalk/departmentGet?agentId=' + environment.dingTalkAgentId;
    return this.http.Post(url, param);
  }
  
  /**
   * 将组织同步至钉钉
   * @param param
   * @returns {Observable<any>}
   */
  synchroToDingtalk(id) {
    const url = this.prefix + 'orgDingtalk/synchroToDingtalk?organizeId='+id;
    return this.http.Post(url,{});
  }

  /**
   * 将已同步至钉钉的组织移除
   * @param param 
   */
  departmentDelete(param) {
    const url = this.out + 'dingtalk/departmentDelete?agentId=' + environment.dingTalkAgentId;
    return this.http.Post(url, param);
  }
  //#endregion


}
